module.exports = __webpack_public_path__ + "static/media/311.319ca952.webp";